import { feedbackStatusLabel } from '../utils';

const statusColor = (status?: string) => {
    switch (status) {
        case 'submitted': return 'text-amber-700 dark:text-amber-300';
        case 'investigating': return 'text-blue-600 dark:text-blue-400';
        case 'resolved':
        case 'regenerated':
        case 'actioned': return 'text-emerald-600 dark:text-emerald-400';
        case 'cannot_resolve': return 'text-red-600 dark:text-red-400';
        default: return 'text-gray-500 dark:text-gray-400';
    }
};

const FeedbackStatus = ({ status, label }: { status?: string; label?: string }) => (
    <span className={`inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium ${statusColor(status)}`}>
        <span aria-hidden='true' className='h-2 w-2 shrink-0 rounded-full bg-current' />
        {status === 'investigating' ? 'Investigating' : feedbackStatusLabel(status, label)}
    </span>
);

export default FeedbackStatus;
